import { Card, Flex } from "antd"
import { Text, Title } from "ui/Typography"
import styles from "./index.module.css"
import Avatar from "components/common/Avatar"
import { spacings } from "themes/variables"
import ReactStars from "react-rating-stars-component"
import PropTypes from "prop-types"
import moment from "moment"

const ReviewItemCard = ({ review }) => {
  const { rating, date, content, author, experience } = review || {}
  const { name } = author || {}

  const starData = {
    count: 5,
    size: 24,
    value: rating,
    edit: false,
    activeColor: "var(--color-primary)",
  }

  return (
    <Card className={styles.reviewItem}>
      <Flex vertical gap={spacings["5XL"]}>
        <Flex vertical gap={spacings.XS}>
          <Flex align="center" gap={spacings.XS}>
            <ReactStars {...starData} />
            <Text fw={500} size="md">
              {moment(date).format("MMMM YYYY")}
            </Text>
          </Flex>
          <Text fw={500}>{content}</Text>
        </Flex>
        <Flex justify="space-between" className={styles.reviewItemAuthor} gap={spacings.XS} align="center">
          <Flex vertical gap={spacings.XS}>
            <Title level={4}>{name}</Title>
            <Text fw={500} size="md">
              {experience}
            </Text>
          </Flex>
          <Avatar size={60} user={author} />
        </Flex>
      </Flex>
    </Card>
  )
}

ReviewItemCard.propTypes = {
  review: PropTypes.object.isRequired
}

export default ReviewItemCard
